import APIDashboard from "@/api/dashboard"
import DashboardConfig from "@/pages/Dashboard/config"
import stores from "@/stores"

export default class DashboardInit {
  static batchGetChartTimer: null | number | NodeJS.Timer = null

  static init(params) {
    DashboardConfig.reset()
    this.batchGetChart(params)
  }

  /**
   * 获取统计数据
   * @param focus
   * @param param
   */
  static getStatistics(params: any = {}) {
    const { ReturnRequestsDataStore } = stores
    const { hasCompare, ...restParams } = params

    ReturnRequestsDataStore.setLoading("dashboardLoading", true)

    async function request() {
      const { ReturnRequestsDataStore, UserInfoStore } = stores
      // 如果 hasCompare 未传递，使用 store 中现有的值
      const finalHasCompare =
        hasCompare !== undefined
          ? hasCompare
          : ReturnRequestsDataStore.hasCompare

      const {
        data: {
          data,
          total_info,
          compare_rate,
          guide,
          manage_return_info,
          app_embed_status,
          index_recommend,
          subscribe_info,
        },
      } = await APIDashboard.getDashboardStatistics(restParams)

      // 设置数据加载完成时间
      UserInfoStore.setUserGuideData(guide, true)
      ReturnRequestsDataStore.setLoading("dashboardLoading", true)
      ReturnRequestsDataStore.setDashboardData({
        data,
        hasCompare: finalHasCompare,
        requests_count: total_info.request_count,
        back_in_store_value: total_info.back_in_store_value,
        pending_review_count: manage_return_info.pending_review_count,
        returns_value: total_info.returns_value,
        pending_refund_count: manage_return_info.pending_refund_count,
        pending_create_exchange_order_count:
          manage_return_info.pending_create_exchange_order_count,
        pending_received_count: manage_return_info.pending_received_count,
        pending_restock_count: manage_return_info.pending_restock_count,
        exchange_upsell_value: total_info.exchange_upsell_value,
        is_open_exchange_other: total_info.is_open_exchange_other,
        total_return_rate: total_info.total_return_rate,
        total_retention_revenue: total_info.total_retention_revenue,
        total_no_cash: total_info.total_no_cash,
        total_return_fee: total_info.total_return_fee,
        total_exchange_rate: total_info.total_exchange_rate,
        total_refund_rate: total_info.total_refund_rate,
        total_retention_revenue_compare: compare_rate?.total_retention_revenue,
        total_return_rate_compare: compare_rate?.return_rate,
        app_embed_status,
        index_recommend,
        subscribe_info,
      })
    }

    request()
  }

  /**
   * 批量读取获取这些数据
   * @param {IManagementStatisticsParam} data 入参需要传day or 开始和结束的时间
   * @param {number} popup_id 弹窗的id
   * @param focus 标识用于参考是否需要重新发送请求
   * @param param 时间参数
   */
  static batchGetChart(param: any) {
    if (typeof this.batchGetChartTimer === "number") {
      clearTimeout(this.batchGetChartTimer)
    }

    this.batchGetChartTimer = setTimeout(() => {
      this.getStatistics(param)
    }, 0)
  }
}
